import PropTypes from 'prop-types';
import Item from '../../../models/Item';

/* eslint-disable function-paren-newline */
const collectionsGroupType = PropTypes.objectOf(
  PropTypes.objectOf(PropTypes.arrayOf(PropTypes.instanceOf(Item)))
);
/* eslint-enable */

export default collectionsGroupType;



// WEBPACK FOOTER //
// ./src/components/common/types/collectionsGroupType.js